export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  JPY: '¥',
  CNY: '¥',
  INR: '₹',
  CHF: 'CHF',
  CAD: 'C$',
  AUD: 'A$',
  SGD: 'S$',
  HKD: 'HK$',
  KRW: '₩',
  AED: 'AED'
} as const;

export const DEFAULT_CURRENCY = 'EUR';

export const SUPPORTED_CURRENCIES = Object.keys(CURRENCY_SYMBOLS);
